<template>
  <transition name="fade">
    <div class="modal-wrap" v-if="isOpen">
      <div class="overlay" @click="closeModal"></div>
      <transition appear name="slide-up">
        <div class="modal-inner-wrap">
          <div class="close" @click="closeModal">
            Stäng
            <icon class="close-icon" fill="white" type="times"></icon>
          </div>
          <div class="modal-content">
            <slot></slot>
          </div>
        </div>
      </transition>
    </div>
  </transition>
</template>

<script>
import Icon from '@/components/Icon'
import { mapGetters } from 'vuex'
import * as types from '@/store/actionTypes'

export default {
  name: 'Modal',
    components: {
    Icon
  },
  props: ['name'],
  computed: {
    ...mapGetters([
      'currentModal'
    ]),
    isOpen() {
      return this.currentModal === this.name
    }
  },
  methods: {
    closeModal() {
      this.$store.commit(types.CLOSE_MODAL)
    }
  }
}
</script>

<style lang="postcss" scoped>
@import '../variables/custom-media.css';

.modal-wrap {
  align-items: center;
  bottom: 0;
  display: flex;
  justify-content: center;
  left: 0;
  position: fixed;
  right: 0;
  top: 0;
  z-index: 2;
}

.overlay {
  background-color: rgba(42, 68, 85, 0.85);
  bottom: 0;
  left: 0;
  position: fixed;
  right: 0;
  top: 0;
}

.modal-inner-wrap {
  position: relative;
  max-width: 90vw;
  z-index: 2;

  @media (--bp-desktop) {
    min-width: 560px;
    max-width: 800px;
  }
}

.close {
  align-items: center;
  color: var(--color-white);
  cursor: pointer;
  display: flex;
  font-weight: 700;
  justify-content: flex-end;
  margin-bottom: var(--spacing-third);
}

.close-icon {
  margin-left: var(--spacing-third);
}

.modal-content {
  background-color: var(--color-white);
  border-radius: 3px;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
  max-height: 90vh;
  overflow-y: auto;
}

/*
// Animations
// ------------------------------------------------*/

.fade-enter-active,
.fade-leave-active {
  transition: opacity 150ms;
}

.fade-enter,
.fade-leave-active {
  opacity: 0;
}

.slide-up-enter-active,
.slide-up-leave-active {
  transition: all 200ms;
}

.slide-up-enter,
.slide-up-leave-active {
  transform: translateY(10px);
}
</style>



// WEBPACK FOOTER //
// src/components/Modal.vue